export default __webpack_public_path__ + "static/media/online_banking.75539f60.svg";